import ProductPage from "../../components/ProductPage";
import { generalInsuranceData } from "../../data/productsData";
export default function GeneralInsurance() { return <ProductPage data={generalInsuranceData} />; }